import { CompositeFilterDescriptor } from "@progress/kendo-data-query";
import { FilterDescriptor } from '@progress/kendo-data-query';
import { CustomFilterCell } from './custom-filter-cell';

export abstract class CustomRangeFilterCell extends CustomFilterCell {
    /**
     * Find the operator
     *
     * @param {string} op
     */
    protected findByOperator(op: string): FilterDescriptor {
        return this.filtersByField(this.column.field)
            .filter(({operator}) => operator === op)[0];
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/filters/classes/custom-range-filter-cell.ts